import myRequest from '@/utils/myRequest'

export async function fetchMyModules() {
  return await myRequest.get('/api/user/modules')
}

export async function activateModuleCode(code, targetModuleCode) {
  return await myRequest.post('/api/user/modules/activate', { code, targetModuleCode })
}
